import React, { useEffect, useRef } from 'react';
import { useLogging } from '../contexts/LoggingContext';
import { setGlobalLogFunction } from '../AuditioBackend';

interface LoggingConnectorProps {
  children: React.ReactNode;
}

export const LoggingConnector: React.FC<LoggingConnectorProps> = ({ children }) => {
  const { addLog } = useLogging();
  const loggingRef = useRef<((message: string, data?: any) => void) | null>(null);
  
  // Update the ref when addLog changes
  useEffect(() => {
    loggingRef.current = addLog;
    console.log('🔗 LoggingConnector: addLog function updated');
  }, [addLog]);
  
  // Set up the global logging function
  useEffect(() => {
    console.log('🔗 LoggingConnector: Setting up global logging function');
    
    const logFunction = (message: string, data?: any) => {
      if (loggingRef.current) {
        loggingRef.current(message, data);
        console.log('🔗 LoggingConnector: Log forwarded to context:', message);
      } else {
        console.warn('🔗 LoggingConnector: No logging function available, falling back to console');
        console.log(`📝 ${message}`, data || '');
      }
    };
    
    setGlobalLogFunction(logFunction);
    
    // Cleanup function
    return () => {
      console.log('🔗 LoggingConnector: Cleaning up global logging function');
    };
  }, []);
  
  return <>{children}</>;
}; 